import { render, staticRenderFns } from "./NewProjectView.vue?vue&type=template&id=f485e3ce&scoped=true"
import script from "./NewProjectView.vue?vue&type=script&lang=ts"
export * from "./NewProjectView.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectView.vue?vue&type=style&index=0&id=f485e3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f485e3ce",
  null
  
)

export default component.exports